import React, { Component } from 'react'
import { PriceDiscount } from './PriceDiscount'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'

import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

import { Image } from './'

import TaggingPrice from 'Catalog/Product/ProductCard/TaggingPrice'
import { InstallmentsWrapper, CashBack } from 'Catalog/Availability/PriceLabel'
class Item extends Component {
  constructor (props) {
    super(props)
    this.update = this.update.bind(this)
    this.delayedUpdate = null

    this.state = {
      removeCartItem: false,
      quantity: (this.props.quantity || 1),
      msgBlurField: ''
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.errorData !== this.props.errorData) {
      if (this.props.errorData &&
        this.props.errorData.subSkus &&
        this.props.errorData.subSkus.some(s => s === this.props.sku)) {
        this.setQuantity(this.props.quantity)
      }
    }
  }

  setQuantity (quantity) {
    this.setState({ quantity })
  }

  removeCartItem = () => {
    this.setState({
      removeCartItem: true
    })
    setTimeout(() => {
      this.remove()
    }, 300)
  }
  remove = () => {
    const { sku, removeItem } = this.props
    removeItem(sku)
  }

  OnChangeInputHandle = e => {
    this.setState({ quantity: parseInt(e.target.value), msgBlurField: 'Saia do campo para salvar' })
  }
  OnBlurInputHandle = () => {
    if (this.state.quantity !== this.props.quantity) {
      this.setState({ msgBlurField: '' })
      if (isNaN(this.state.quantity) || parseInt(this.state.quantity) < 1) {
        this.setState({ quantity: 1 })
      }
      this.update(this.state.quantity.toString())
    }
  }

  Addition () {
    const quantity = parseInt(this.state.quantity) + 1
    this.setState({ quantity })

    setTimeout(() => {
      this.update(this.state.quantity.toString())
    }, 300)
  }

  Subtraction () {
    const quantity = parseInt(this.state.quantity) - 1
    this.setState({ quantity })

    setTimeout(() => {
      this.update(this.state.quantity.toString())
    }, 300)
  }

  update (quantity) {
    const data = {
      sku: this.props.sku,
      vendorId: this.props.vendor.id,
      quantity: quantity < 1 ? 1 : quantity,
      email: this.props.email
    }
    this.props.updateItem(data)
    setTimeout(() => {
      this.props.sendGTM()
    }, 5000)
  }

  convertCurrency (value, fixed) {
    const number = parseFloat(value)

    return number
      .toFixed(fixed)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  render () {
    return (
      <div className='cart-item row px-2 border-color-ui-3 border-bottom py-2'>

        {
          this.state.removeCartItem
            ? (
              <TaggingPrice
                type='removeCart'
                identifier='removeCart'
                position='0'
                sku={this.props.sku}
                name={this.props.name}
                quantity={this.props.quantity.toString()}
                price={{
                  points: this.props.price,
                  cash:
                  (this.props.cash && this.props.cash.sellingPrice) || 0
                }}
              />
            )
            : ''
        }
        <div className='cart-img col-auto txt-center pl-1 pt-1 pb-1 pr-2'>
          <Image
            src={`${this.props.imageUrl}`}
            alt={''}
            className='img-w-auto'
            aria-hidden='true'
          />
        </div>
        <div className='cart-product-info col col-md'>
          <div className='row'>
            <div className='col col-md'>
              <div className='cart-product-info row'>
                <div className='product-infos col-12 mx-0'>
                  <h2 className='txt-font-body txt-body-sm color-ui-2'>
                    <Link
                      className='txt-font-body txt-body-sm color-ui-2'
                      to={`/products/${this.props.sku}`}
                    >
                      {this.props.name}{ !this.props.ready && <i className='icon icon_loading icon-ssm' aria-hidden='true' /> }
                    </Link>
                  </h2>
                </div>
              </div>
              <div className='row card-price-item mt-1'>
                <PriceDiscount {...this.props} />
                <div className='card-price-points col-12 txt-title-3 txt-circular-book txt-left color-ui-1'>
                  <CatalogCurrencyLabel
                    price={{
                      points: this.props.price,
                      cash:
                        (this.props.cash && this.props.cash.sellingPrice) || 0
                    }}
                    checkCashOnly
                  />
                </div>
                <div className='col-12 my-1'>
                  <div className='row'>
                    <CashBack
                      hideIcon
                      price={(this.props.cash && this.props.cash.sellingPrice)}
                      currency={this.props.currency}
                      hasCashBack={process.env.REACT_APP_HAS_CASHBACK}
                      ruleCashBack={process.env.REACT_APP_RULE_CASHBACK || '1'}
                    />
                    <InstallmentsWrapper hideAllInstallments showInstallments hideIcon sku={this.props.sku} vendorId={this.props.vendor && this.props.vendor.id} currentPrice={(this.props.cash && this.props.cash.sellingPrice)} currency={this.props.currency} />
                  </div>
                </div>
              </div>
              <div className='row product-brand mt-1'>
                <div className='col-12'>
                  {this.props.vendorName && this.props.vendorName !== 'Compra de Pontos' ? (
                    <p className='txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                      <span>Fornecido e entregue por: <strong>{this.props.vendorName}</strong></span>
                    </p>
                  ) : (
                    ''
                  )}

                  {this.props.deliveryDate ? (
                    <p className='txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
                      <span>Previsão de entrega: <strong>{this.props.deliveryDate}</strong></span>
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
            <div className='cart-action pos-relative col-12 col-md-auto txt-center mt-1 mt-md-0'>
              <div className='cart-action-row row align-items-center h-100'>
                <div
                  className='col-auto col-md-12'
                  sku={this.props.sku}
                >
                  <div className='cart-product-quantity form-field px-0 stix-quantity form-field'>
                    <p role='status' className='hide-absolute'>{this.state.msgBlurField}</p>
                    <div className='box-spinner pos-relative'>
                      <a
                        href='javascript:void(0)'
                        className='quantity-button icon icon_remove quantity-down'
                        onClick={() => this.props.ready && this.Subtraction()}
                        role='button'
                        aria-label={this.props.ready ? 'Subtrair um a quantidade' : 'Carregando'}
                        aria-disabled={!this.props.ready}
                      />
                      <input
                        type='number'
                        className='input-spinner-vertical no-label qtd-points'
                        aria-label={this.props.ready ? 'Quantidade' : 'Carregando'}
                        placeholder='Quantidade'
                        min={1}
                        value={this.state.quantity}
                        step={1}
                        required
                        onChange={(e) => this.props.ready && this.OnChangeInputHandle(e)}
                        onBlur={(e) => this.props.ready && this.OnBlurInputHandle(e)}
                        readOnly={!this.props.ready}
                        aria-disabled={!this.props.ready}
                      />
                      <a
                        href='javascript:void(0)'
                        className='quantity-button icon icon_more quantity-up'
                        onClick={() => this.props.ready && this.Addition()}
                        role='button'
                        aria-label={this.props.ready ? 'Adicionar um a quantidade' : 'Carregando'}
                        aria-disabled={!this.props.ready}
                      />
                    </div>
                  </div>
                  <div className='cart-product-remove txt-center'>
                    <a
                      href='#'
                      className='txt-body-sm color-ui-2 btn btn-sm btn-flat txt-initial txt-font-body py-1'
                      onClick={this.removeCartItem}
                    >
                      <span aria-hidden='true' className='color-links border-color-links'>Remover</span>
                      <span className='hide-absolute'>Remover produto</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Item.propTypes = {
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }),
  sku: PropTypes.string,
  removeItem: PropTypes.func,
  vendor: PropTypes.object,
  email: PropTypes.string,
  updateItem: PropTypes.func,
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  deliveryDate: PropTypes.any,
  quantity: PropTypes.number,
  vendorName: PropTypes.string,
  ready: PropTypes.bool,
  onlyCash: PropTypes.bool,
  cash: PropTypes.object,
  pointsName: PropTypes.string,
  decimalPlaces: PropTypes.number,
  sendGTM: PropTypes.func,
  items: PropTypes.array,
  errorData: PropTypes.object
}

const mapStateToProps = ({ catalog }) => {
  const {
    currencyConfiguration: {
      pointsName: name,
      decimalPlaces
    }
  } = catalog
  return ({
    currency: {
      name,
      decimalPlaces
    }
  })
}

export default connect(mapStateToProps)(Item)



// WEBPACK FOOTER //
// ./src/features/Cart/Item/Item.js